import React from 'react';
import { Link } from 'react-router-dom';
import { GridBackground } from '../GridBackground';
import { Spotlight } from '../ui/Spotlight';

const PoliticaDePrivacidad = () => {
  return (
    <div className="relative min-h-screen bg-black text-white overflow-hidden">
      <GridBackground />
      <Spotlight className="-top-40 left-0 md:-top-20 md:left-60" fill="white" />

      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center p-4">
        <div className="w-full max-w-4xl bg-neutral-900/80 backdrop-blur-md border border-neutral-700 rounded-2xl shadow-2xl p-8 mt-12 mb-8">
          <div className="mb-8 flex items-center justify-between">
            <Link to="/descargar-app" className="bebas-font text-2xl text-neutral-400 hover:text-neutral-300 transition-colors tracking-widest flex items-center gap-2">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
              VOLVER A APP
            </Link>
          </div>
          <h1 className="bebas-font text-5xl text-center tracking-wider mb-6 text-white">
            Política de Privacidad
          </h1>
          <div className="space-y-6 text-neutral-400 leading-relaxed">
            <section>
              <h2 className="bebas-font text-3xl text-neutral-200 mb-2">I. Identidad del Titular</h2>
              <p>La presente Política de Privacidad regula el tratamiento de los datos personales proporcionados por los usuarios en la plataforma web de GIMNASIO ENERGY HUANUCO, con ubicación en Huánuco, Perú.</p>
            </section>
            <section>
              <h2 className="bebas-font text-3xl text-neutral-200 mb-2">II. Datos Personales Recabados</h2>
              <p>Para el funcionamiento de la app, tratamos:</p>
              <ul className="list-disc list-inside ml-4 mt-2 space-y-1">
                <li><strong>Datos identificativos:</strong> Nombre, correo electrónico.</li>
                <li><strong>Datos físicos (Opcionales):</strong> Edad, peso, estatura y sexo (utilizados exclusivamente para el cálculo de métricas de rendimiento físico, IMC o seguimiento de entrenamientos).</li>
                <li><strong>Imágenes(Opcionales):</strong> Fotografías de perfil subidas directamente por el usuario.</li>
              </ul>
            </section>
            <section>
              <h2 className="bebas-font text-3xl text-neutral-200 mb-2">III. Finalidad del Tratamiento</h2>
              <p>Los datos se utilizan exclusivamente para:</p>
              <ul className="list-disc list-inside ml-4 mt-2 space-y-1">
                <li>Personalizar la experiencia del usuario y calcular indicadores de salud.</li>
                <li>Gestión de la cuenta y autenticación.</li>
                <li>Envío de notificaciones relacionadas con el servicio.</li>
              </ul>
            </section>
            <section>
              <h2 className="bebas-font text-3xl text-neutral-200 mb-2">IV. Consentimiento Informado</h2>
              <p>De acuerdo con la Ley N° 29733, el usuario brinda su consentimiento previo, informado, expreso e inequívoco al marcar la casilla de "Acepto Políticas de Privacidad" antes del registro.</p>
            </section>
            <section>
              <h2 className="bebas-font text-3xl text-neutral-200 mb-2">V. Derechos ARCO</h2>
              <p>El usuario puede ejercer en cualquier momento sus derechos de Acceso, Rectificación, Cancelación y Oposición (ARCO), así como revocar el consentimiento otorgado o solicitar la eliminación definitiva de su cuenta y métricas asociadas, enviando una solicitud a:</p>
              <ul className="list-disc list-inside ml-4 mt-2 space-y-1">
                <li><strong>Correo electrónico:</strong> [EMAIL_ADDRESS]</li>
                <li><strong>Asunto:</strong> Ejercicio de Derechos ARCO - [Nombre de Usuario]</li>
              </ul>
            </section>
            <section>
              <h2 className="bebas-font text-3xl text-neutral-200 mb-2">VI. Seguridad de la Información</h2>
              <p>Implementamos medidas técnicas y organizativas para evitar la alteración, pérdida o acceso no autorizado a sus datos.</p>
            </section>
            <section>
              <h2 className="bebas-font text-3xl text-neutral-200 mb-2">VII. Compartición y Confidencialidad de Datos</h2>
              <p>Nos comprometemos a no vender, ceder ni compartir sus datos personales con terceros, salvo obligación legal o que usted otorgue su consentimiento expreso. Sus datos serán tratados con la máxima confidencialidad y solo serán accesibles por el personal autorizado para las finalidades descritas en esta política.</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoliticaDePrivacidad;
